import { render } from "./ProductVersion.vue?vue&type=template&id=4ae15e57&scoped=true"
import script from "./ProductVersion.vue?vue&type=script&lang=js"
export * from "./ProductVersion.vue?vue&type=script&lang=js"

import "./ProductVersion.vue?vue&type=style&index=0&id=4ae15e57&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae15e57"]])

export default __exports__